import toastr from 'toastr';
import moment from 'moment';
import { I18n } from "i18n-js";
const i18n = new I18n();

export function schoolOverviewSetup() {
  var $schoolSelect = $('.school-select-js');
  var $schoolClassSelect = $('.school-class-select-js');
  var $datePicker = $('.overview-picker .date');

  $schoolSelect.change(function() {
    var $report = $(this).parents('.report-content')

    var $schoolClassOverview = $report.find('.school-class-days-overview')
    $schoolClassOverview.html('');

    getSchoolClassesOverview($report);
    getSchoolClassSelectData($report);
  });

  $schoolClassSelect.change(function() {
    var $report = $(this).parents('.report-content');

    getSchoolClassDaysOverview($report);

  });

  $datePicker.change(datepickerChange);
}

export function datepickerChange() {
  var $report = $(this).parents('.report-content');

  if (!isDateIntervalValid($report)) return;

  getSchoolsOverview($report);
  getSchoolClassesOverview($report);
  getSchoolClassDaysOverview($report);
}

function selectData(data, $select) {
  $.each(data, function(key, value) {
    $select
      .append($("<option></option>")
        .attr("value", value.id)
        .text(value.name)
      );
  });
}

function getSchoolClassSelectData($report) {
  var schoolId = $report.find('.school-select-js option:selected').val();

  if (!schoolId) return;

  var $selectSchoolClass = $report.find('.school-class-select-js');
  $selectSchoolClass.find('option:not(:first)').remove()

  $.ajax({
    method: 'GET',
    url: '/api/v2/school_classes',
    data: {
      school_id: schoolId
    },
    success: function(data) {
      selectData(data, $selectSchoolClass);
    },
    error: function(data) {
      toastr.error(data.responseJSON.message);
    }
  });
}

function getSchoolClassDaysOverview($report) {
  var schoolClassId = $report.find('.school-class-select-js option:selected').val();

  if (!schoolClassId) return;

  var schoolYearId = $report.data('value');
  var initialDate = $report.find('.overview-picker .start-date-js').val();
  var finalDate = $report.find('.overview-picker .end-date-js').val();

  $.ajax({
    method: 'GET',
    url: './reports/school_class_days_overview',
    data: {
      school_year_id: schoolYearId,
      school_class_id: schoolClassId,
      initial_date: initialDate,
      final_date: finalDate
    },
    success: function(response) {
      var $schoolClassDaysOverview = $report.find('.school-class-days-overview');
      $schoolClassDaysOverview.html(response);
    },
    error: function(data) {
      toastr.error(data.responseJSON.message);
    }
  });
}

function getSchoolClassesOverview($report) {
  var schoolId = $report.find('.school-select-js option:selected').val();

  if (!schoolId) return;

  var schoolYearId = $report.data('value');
  var initialDate = $report.find('.overview-picker .start-date-js').val();
  var finalDate = $report.find('.overview-picker .end-date-js').val();

  $.ajax({
    method: 'GET',
    url: './reports/school_classes_overview',
    data: {
      school_year_id: schoolYearId,
      school_id: schoolId,
      initial_date: initialDate,
      final_date: finalDate
    },
    success: function(response) {
      var $schoolClassesOverview = $report.find('.school-classes-overview');
      $schoolClassesOverview.html(response);
    },
    error: function(data) {
      toastr.error(data.responseJSON.message);
    }
  });
}

function getSchoolsOverview($report) {
  var schoolYearId = $report.data('value');
  var initialDate = $report.find('.overview-picker .start-date-js').val();
  var finalDate = $report.find('.overview-picker .end-date-js').val();

  $.ajax({
    method: 'GET',
    url: './reports/schools_overview',
    data: {
      school_year_id: schoolYearId,
      initial_date: initialDate,
      final_date: finalDate
    },
    success: function(response) {
      var $schoolOverview = $report.find('.schools-overview');
      $schoolOverview.html(response);
    },
    error: function(data) {
      toastr.error(data.responseJSON.message);
    }
  });
}

function isDateIntervalValid($report) {
  var initialDate = $report.find('.overview-picker .start-date-js').val();
  var finalDate = $report.find('.overview-picker .end-date-js').val();

  if (!initialDate || !finalDate || moment(finalDate, 'DD/MM/YYYY').isAfter(moment(initialDate, 'DD/MM/YYYY'))) {
    return true;
  }

  toastr.warning(i18n.t('views.reports.index.date_validation_error'));
  return false;
}
